module.exports = __webpack_public_path__ + "img/TW.10756b99.svg";